.sections {
    display: flex;
    flex-direction: column;
    gap: 2em;
}

tr.new-row {
    background-color: #ffc;
}

td.edit-publisher {
    padding: 4px;
}

td.edit-button {
    font-size: 70%;
    padding: 2px 4px;
    text-align: right;
}

button.delete-button {
    color: white;
    background-color: rgb(202, 60, 60);
}

td.profile-picture {
    text-align: center;
    padding: 0;
}

td.profile-picture img {
    height: 3em;
    width: 3em;
    display: block; /* needed to avoid a mysterious 4px margin below the image */
}
